//  パスワードの有効期限切れダイアログ
import React from 'react';
import Dialog from './Dialog';
var PasswordExpiredDialog = function (_a) {
    var okCallback = _a.okCallback, open = _a.open, t = _a.t;
    return (React.createElement(Dialog, { label: t('パスワードの有効期限切れ'), body: React.createElement("p", null,
            t('パスワードの有効期限が切れています。'),
            React.createElement("br", null),
            t('パスワードを変更してください。')), ok: 'OK', okCallback: okCallback, open: open }));
};
export default PasswordExpiredDialog;
